import React from 'react';
import { useSelector } from 'react-redux';

function CheckinSummary() {
    const checkinSummary = useSelector(
        (state) => state.posReportshiftSlice.shiftReporCheckinSummary
    );
    const decimalPosition = localStorage.getItem("decimalPosition");
    console.log(checkinSummary);

    const checkinRecords = checkinSummary?.empCheckIn || [];

    const formatDate = (dateString) => {
        if (!dateString) return '--';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        } catch (e) {
            return dateString;
        }
    };

    const formatTime = (timeString) => {
        if (!timeString) return '--';
        return timeString;
    };

    return (
        <div style={{ paddingInline: "11px" }}>
            {/* Show No Data if checkinRecords is empty and branchWiseShift is not false */}
            {checkinRecords.length === 0 && checkinSummary?.branchWiseShift !== false && (
                <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '18px', color: '#666' }}>
                    No data available
                </div>
            )}

            {checkinRecords.map((checkin, idx) => {
                const paymentData = checkin.posOrderCount?.cashCardSummary.data || [];
                const orderData = checkin.posOrderCount?.posOrderSummary || [];

                const totalPayment = paymentData.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
                const totalOrders = orderData.reduce((sum, item) => sum + (item.count || 0), 0);
                const totalOrderAmount = orderData.reduce((sum, item) => sum + (item.amtTotal || 0), 0);

                return (
                    <div key={checkin._id} style={{ marginBottom: "40px", borderBottom: "2px solid #ccc", paddingBottom: "20px" }}>
                        {/* Main Header */}
                        <div style={{
                            backgroundColor: 'rgb(183 196 230)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px 20px',
                            fontWeight: 'bold'
                        }}>
                            <span>{checkin.empData?.staff_name || '--'}</span>
                            <div style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
                                <span style={{ color: 'green' }}>🟢 Check In: {checkin.checkInDate}</span>
                                <span style={{ color: '#000' }}>🟣 Time: {checkin.checkInTime}</span>
                                {checkin.checkOutDate && (
                                    <>
                                        <span style={{ color: 'red' }}>🔴 Check Out: {checkin.checkOutDate}</span>
                                        <span style={{ color: '#000' }}>🔵 Time: {checkin.checkOutTime}</span>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Payment Summary */}
                        <div style={{ marginTop: '20px' }}>
                            <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold', marginTop: "-16px" }}>
                                Payment Summary
                            </div>

                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead>
        <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
            <th style={{ padding: '10px' }}>Type</th>
            <th style={{ padding: '10px' }}>Commission</th>
            <th style={{ padding: '10px', textAlign: 'right' }}>Total</th>
        </tr>
    </thead>
    <tbody>
        {paymentData.length === 0 ? (
            <tr>
                <td colSpan="3" style={{ padding: '10px', textAlign: 'center', color: '#999' }}>
                    No record found
                </td>
            </tr>
        ) : (
            <>
                {paymentData?.map((item, index) => (
                    <React.Fragment key={index}>
                        <tr style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                            <td style={{ padding: '10px', textTransform: 'capitalize' }}>{item.name}</td>
                            <td style={{ padding: '10px' }}>₹{(item.totalCommission)?.toFixed(2) || ""}</td>
                            <td style={{ padding: '10px', textAlign: 'right' }}>₹{(item.totalAmount || 0)?.toFixed(2)}</td>
                        </tr>

                       {item?.type === 'cash' && item?.denomination?.length > 0 && (
  <tr>
    <td colSpan={3} style={{ padding: '0px 0px 3px 16px' }}>
      <div style={{
        backgroundColor: '#f9f9f9',
        padding: '6px',
        borderRadius: '5px',
        maxWidth: '100%'
      }}>
        <div style={{ fontWeight: 'bold', marginBottom: '8px', backgroundColor: "#cab8b8" }}>
          Denomination
        </div>
        <table style={{ width: '100%', fontSize: '14px' }}>
          <thead>
            <tr style={{ fontWeight: 'bold' }}>
              <td>Currency</td>
              <td>Count</td>
              <td>Total</td>
            </tr>
          </thead>
          <tbody>
            {item.denomination.map((den, i) => (
              <tr key={i}>
                <td>₹{den.currency}</td>
                <td>{den.count}</td>
                <td>₹{den.currency * den.count}</td>
              </tr>
            ))}
            {/* Total row */}
            <tr style={{ fontWeight: 'bold', borderTop: '1px solid #ccc' }}>
              <td colSpan={2} style={{ textAlign: 'right', paddingTop: '8px' }}>Grand Total:</td>
              <td style={{ paddingTop: '8px' }}>
                ₹{item.denomination.reduce((acc, den) => acc + (den.currency * den.count), 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </td>
  </tr>
)}

                           {item?.description?.trim() && (
  <tr>
    <td colSpan={3} >
     <p style={{ padding: "8px", backgroundColor: "rgb(161, 168, 177)",margin:"0 0 0 16px" }}> Description: {item.description}</p>
    </td>
  </tr>
)}

                    </React.Fragment>

                ))}
                <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                    <td style={{ padding: '10px' }}>Total</td>
                    <td></td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>₹{totalPayment.toFixed(2)}</td>
                </tr>
            </>
        )}
    </tbody>
</table>

                        </div>

                        {/* Order Summary */}
                        <div style={{ marginTop: '30px' }}>
                            <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold' }}>
                                Order Summary
                            </div>
                         <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead>
        <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
            <th style={{ padding: '10px' }}>Type</th>
            <th style={{ padding: '10px' }}>Count</th>
            <th style={{ padding: '10px', textAlign: 'right' }}>Amount</th>
        </tr>
    </thead>
    <tbody>
        {orderData.length === 0 ? (
            <tr>
                <td colSpan="3" style={{ padding: '10px', textAlign: 'center', color: '#999' }}>
                    No record found
                </td>
            </tr>
        ) : (
            <>
                {orderData.map((order, i) => (
                    <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                        <td style={{ padding: '10px' }}>{order.ordType}</td>
                        <td style={{ padding: '10px' }}>{order.count}</td>
                        <td style={{ padding: '10px', textAlign: 'right' }}>{order.amtTotal}</td>
                    </tr>
                ))}
                <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                    <td style={{ padding: '10px' }}>Total</td>
                    <td style={{ padding: '10px' }}>{totalOrders}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{totalOrderAmount}</td>
                </tr>
            </>
        )}
    </tbody>
</table>

                        </div>
                    </div>
                );
            })}

            {/* Branch-wise shift false section */}
            {checkinSummary?.branchWiseShift === false &&
                (checkinSummary?.cashCardSummary?.data?.length > 0 || checkinSummary?.posOrderSummary?.length > 0) ? (
                    <div style={{ marginBottom: "40px", borderBottom: "2px solid #ccc", paddingBottom: "20px" }}>
                        <div style={{
                            backgroundColor: 'rgb(183 196 230)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px 20px',
                            fontWeight: 'bold'
                        }}>
                            <span>{checkinSummary?.shiftData?.shiftSeq || '--'}</span>
                            <div style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
                                <span style={{ color: 'green' }}>🟢 Check In: {checkinSummary?.shiftData?.startDate}</span>
                                <span style={{ color: '#000' }}>🟣 Time: {checkinSummary?.shiftData?.startTime}</span>
                                <span style={{ color: 'red' }}>🔴 Check Out: {checkinSummary?.shiftData?.endDate}</span>
                                <span style={{ color: '#000' }}>🔵 Time: {checkinSummary?.shiftData?.endTime}</span>
                            </div>
                        </div>

                        {/* Payment Summary */}
                        <div style={{ marginTop: '20px' }}>
                            <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold', marginTop: "-16px" }}>
                                Payment Summary
                            </div>

                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
                                        <th style={{ padding: '10px' }}>Type</th>
                                        <th style={{ padding: '10px' }}>Commission</th>
                                        <th style={{ padding: '10px', textAlign: 'right' }}>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {checkinSummary?.cashCardSummary?.data?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <tr style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                                <td style={{ padding: '10px', textTransform: 'capitalize' }}>{item?.name}</td>
                                                <td style={{ padding: '10px' }}>₹{(item?.totalCommission || 0)?.toFixed(2)}</td>
                                                <td style={{ padding: '10px', textAlign: 'right' }}>₹{(item?.totalAmount || 0)?.toFixed(2)}</td>
                                            </tr>
                                            {item?.type === 'cash' && item.denomination?.length > 0 && (
                                                <tr>
                                                    <td colSpan={3} style={{ padding: '0px 0px 3px 16px' }}>
                                                        <div style={{
                                                            backgroundColor: '#f9f9f9',
                                                            padding: '6px',
                                                            borderRadius: '5px',
                                                            maxWidth: '100%'
                                                        }}>
                                                            <div style={{ fontWeight: 'bold', marginBottom: '8px', backgroundColor: "#cab8b8" }}>Denomination</div>
                                                            <table style={{ width: '100%', fontSize: '14px' }}>
                                                                <thead>
                                                                    <tr style={{ fontWeight: 'bold' }}>
                                                                        <td>Currency</td>
                                                                        <td>Count</td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {item.denomination.map((den, i) => (
                                                                        <tr key={i}>
                                                                            <td>₹{den.currency}</td>
                                                                            <td>{den.count}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                                        <td style={{ padding: '10px' }}>Total</td>
                                        <td></td>
                                        <td style={{ padding: '10px', textAlign: 'right' }}>
                                            ₹{checkinSummary?.cashCardSummary?.amountTotal?.toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Order Summary */}
                        <div style={{ marginTop: '30px' }}>
                            <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold' }}>
                                Order Summary
                            </div>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
                                        <th style={{ padding: '10px' }}>Type</th>
                                        <th style={{ padding: '10px' }}>Count</th>
                                        <th style={{ padding: '10px', textAlign: 'right' }}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {checkinSummary?.posOrderSummary?.map((order, i) => (
                                        <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                            <td style={{ padding: '10px' }}>{order.ordType}</td>
                                            <td style={{ padding: '10px' }}>{order.count}</td>
                                            <td style={{ padding: '10px', textAlign: 'right' }}>{order.amtTotal}</td>
                                        </tr>
                                    ))}
                                    <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                                        <td style={{ padding: '10px' }}>Total</td>
                                        <td></td>
                                        <td style={{ padding: '10px', textAlign: 'right' }}>
                                            ₹{checkinSummary?.posOrderSummary?.reduce((sum, order) => sum + (order.amtTotal || 0), 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : checkinSummary?.branchWiseShift === false && (
                    <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '18px', color: '#666' }}>
                        No data available
                    </div>
                )}
        </div>
    );
}

export default CheckinSummary;
